export const PUSH_TO_CAMPAIGN_OFFLINE_SALES = 'PUSH_TO_CAMPAIGN_OFFLINE_SALES';
export const PUSH_TO_POS_OFFLINE_SALES = 'PUSH_TO_POS_OFFLINE_SALES';

// Mobile Offline Sales User Validation
export const SALESMAN_ID_VERIFY = 'checkout/SALESMAN_ID_VERIFY';
export const SALESMAN_ID_VERIFY_SUCCESS = 'checkout/SALESMAN_ID_VERIFY_SUCCESS';
export const SALESMAN_ID_VERIFY_FAIL = 'checkout/SALESMAN_ID_VERIFY_FAIL';
